import useTranslation from 'next-translate/useTranslation'
import { memo } from 'react'

function Quantity({ quantity }: QuantityProps) {
  const { t } = useTranslation('global')

  return (
    <div className="space-y-4">
      {quantity > 2 && (
        <p className="text-gray-150">{t('products_avaliable')}</p>
      )}
      {quantity === 2 && (
        <p className="text-gray-150">{t('products_two_pieces_left')}</p>
      )}
      {quantity === 1 && (
        <p className="text-gray-150">{t('products_last_piece_left')}</p>
      )}
    </div>
  )
}

interface QuantityProps {
  quantity: number
}

export default memo(Quantity)
